import { alpha } from "@material-ui/core/styles";

// Os tons 50/100 do MUI não mudam com palette.type: no escuro viram as variantes abaixo
export const isDarkTheme = (theme) => theme.palette.type === "dark";

// Fundo claro + texto escuro; no tema escuro, fundo translúcido + texto claro
export const tintStyle = (isDark, palette, bgShade = 50, fgShade = 800) => ({
  backgroundColor: isDark ? alpha(palette[500], 0.2) : palette[bgShade],
  color: isDark ? palette[300] : palette[fgShade],
});
